import React, { useContext } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

import { DropdownContext } from './DropdownContext';

export const DropdownButton = ({ children, className }: DefaultBsComponent) => {
  const context = useContext(DropdownContext);

  return (
    <button
      className={classNames(
        'DropdownButton',
        className,
        'inline-flex justify-between rounded-8 cursor-pointer hover:bg-lang-31',
        'item-center px-[9px] py-12 shadow-btnLight',
        'border-silver-100 border transition duration-[200ms]',
        'ease-linear  text-neutral-301 text-14 text-center',
        context.open ? 'bg-lang-31' : 'bg-white'
      )}
      type="button"
      aria-haspopup="menu"
      aria-expanded={context.open}
      onClick={context.toggle}
      onKeyDown={context.toggle}
    >
      {children}
    </button>
  );
};
